import React, { Component } from 'react';
import { Switch, Redirect, BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';

import { loggedUserRequest } from '@redux/actions/AuthActions';
import Feedback from 'pages/Investor/Feedback';
import Logout from 'pages/Investor/Logout';
import Discuss from 'pages/Investor/Discuss';
import { Topbar } from 'layouts/Main/components';
import { MenuItems } from '@utils/constants';
import { switchUserId } from 'redux/actions/AuthActions';
import { Button } from '@material-ui/core';
import {
  BackendError,
  NotFound,
  Signin,
  Register,
  PasswordReset,
  Home,
  Informed,
  Information,
  Feedbacks,
  Investors,
  Invest,
  FinancialModel
} from './pages';
import { RouteWithLayout, RouteWithLayoutProtected } from './components';
import {
  Main as MainLayout,
  Minimal as MinimalLayout,
  Empty as EmptyLayout
} from './layouts';

class RoutesComponent extends Component {
  componentDidMount() {
    this.props.loggedUser();
  }

  render() {
    const { authenticated, userId, switchUser } = this.props;

    // TODO: implement roles
    // investor or entrepreneur

    return (
      <Router>
        {userId === 'entrepreneur' && authenticated && (
          <Topbar items={MenuItems} />
        )}
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            height: 45,
            padding: 15,
            width: '100%',
            textAlign: 'left',
            zIndex: 1222
          }}>
          <Button
            onClick={() => switchUser()}
            style={{
              cursor: 'pointer'
            }}>
            switch user
          </Button>
        </div>

        <Switch>
          <RouteWithLayout
            authenticated={authenticated}
            component={NotFound}
            exact
            layout={EmptyLayout}
            path="/404"
          />
          <RouteWithLayout
            authenticated={authenticated}
            component={BackendError}
            exact
            layout={EmptyLayout}
            path="/500"
          />

          <RouteWithLayout
            authenticated={authenticated}
            component={Signin}
            exact
            layout={EmptyLayout}
            path="/"
          />

          <RouteWithLayout
            authenticated={authenticated}
            component={Register}
            exact
            layout={EmptyLayout}
            path="/register/:id"
          />
          <RouteWithLayout
            authenticated={authenticated}
            component={PasswordReset}
            exact
            layout={EmptyLayout}
            path="/forgot"
          />
          <RouteWithLayout
            authenticated={authenticated}
            component={PasswordReset}
            exact
            layout={EmptyLayout}
            path="/reset/:id?"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={userId === 'entrepreneur' ? Home : Informed}
            exact
            layout={userId === 'entrepreneur' ? MainLayout : MinimalLayout}
            path="/panel"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Informed}
            exact
            layout={MinimalLayout}
            path="/informed"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Feedback}
            exact
            layout={MinimalLayout}
            path="/newfeedback"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={FinancialModel}
            exact
            layout={MinimalLayout}
            path="/financialmodel"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Invest}
            exact
            layout={MinimalLayout}
            path="/invest"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Discuss}
            exact
            layout={MinimalLayout}
            path="/discuss"
          />
          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Logout}
            exact
            layout={MinimalLayout}
            path="/logout"
          />

          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Information}
            exact
            layout={MainLayout}
            path="/information"
          />

          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Feedbacks}
            exact
            layout={MainLayout}
            path="/feedbacks"
          />

          <RouteWithLayoutProtected
            authenticated={authenticated}
            component={Investors}
            exact
            layout={MainLayout}
            path="/investors"
          />

          <Redirect to="/404" />
        </Switch>
      </Router>
    );
  }
}

export const mapStateToProps = (state) => ({
  authenticated: state.AuthReducer.authenticated,
  userId: state.AuthReducer.userId
});

export const mapDispatchToProps = (dispatch) => {
  return {
    loggedUser: () => dispatch(loggedUserRequest()),
    switchUser: () => dispatch(switchUserId())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutesComponent);
